import type { Components } from '@mui/material/styles';

export default function MuiSnackbarContent(): Components['MuiSnackbarContent'] {
  return {};
}
